import ListaDesplegable from '../../ComponentesGlobales/ListaDesplegable'
import BuscadorMercaderias from '../../ComponentesGlobales/BuscadorMercaderias'
import { useStoreIngresos } from './useStoreIngresos'
import Calendario from '../../ComponentesGlobales/Calendario'
import { BlockUI } from 'primereact/blockui';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment';
import { InputNumber } from 'primereact/inputnumber';
import { useEffect, useState } from 'react';
import { MensajeInfo } from '../../componentes/FuncionesLocales';
import { formatearCategoriaFiscal } from '../../servicios/categoriasFiscales';


export default function IngresosTab2() {
  const Mercaderia = useStoreIngresos((state) => state.Mercaderia);
  const Lote = useStoreIngresos((state) => state.Lote);
  const Peso = useStoreIngresos((state) => state.Peso);
  const FechaVencimiento = useStoreIngresos((state) => state.FechaVencimiento);
  const Fecha = useStoreIngresos((state) => state.Fecha);
  const Procesando = useStoreIngresos((state) => state.Procesando);
  const Proveedor = useStoreIngresos((state) => state.Proveedor);
  const Etiquetas = useStoreIngresos((state) => state.Etiquetas);
  const ListaUnidades = useStoreIngresos((state) => state.ListaUnidades);
  const buscandoUnidades = useStoreIngresos((state) => state.buscandoUnidades);
  const Unidad = useStoreIngresos((state) => state.Unidad);
  const EsProductoTerminado = useStoreIngresos((state) => state.EsProductoTerminado);
  const Cantidad = useStoreIngresos((state) => state.Cantidad);
  const PrecioCosto = useStoreIngresos((state) => state.PrecioCosto);
  const PrecioVenta = useStoreIngresos((state) => state.PrecioVenta);
  const ListaCategoriasFiscales = useStoreIngresos((state) => state.ListaCategoriasFiscales);
  const CategoriaFiscal = useStoreIngresos((state) => state.CategoriaFiscal);
  const CargandoCategoriasFiscales = useStoreIngresos((state) => state.CargandoCategoriasFiscales);
  const ErrorCategoriasFiscales = useStoreIngresos((state) => state.ErrorCategoriasFiscales);
  const EsMercaderiaNueva = !Number(Mercaderia?.Id);

  const [open, setOpen] = useState(false);




  const Guardar = () => {
    if (moment(Fecha).format("YYYYMMDD") > moment(FechaVencimiento).format("YYYYMMDD")) {
      MensajeInfo("La fecha de vencimiento no puede ser anterior a la fecha de ingreso.", "", "info");
      return;
    }
    if (!Proveedor || String(Proveedor) === "") {
      MensajeInfo("Debe seleccionar un proveedor.", "", "info");
      return;
    }
    if (!Unidad || String(Unidad) === "") {
      MensajeInfo("Debe seleccionar una unidad.", "", "info");
      return;
    }
    if (!Mercaderia || String(Mercaderia) === "") {
      MensajeInfo("Debe seleccionar una mercadería.", "", "info");
      return;
    }
    if (Number(EsProductoTerminado ? Cantidad : Peso) <= 0) {
      MensajeInfo("La cantidad debe ser mayor a 0.", "", "info");
      return;
    }
    if (EsProductoTerminado && Number(PrecioCosto) < 0) {
      MensajeInfo("El precio de costo no puede ser negativo.", "", "info");
      return;
    }
    if (EsProductoTerminado && Number(PrecioVenta) <= 0) {
      MensajeInfo("El precio de venta debe ser mayor a 0.", "", "info");
      return;
    }
    if (EsMercaderiaNueva && !CategoriaFiscal?.Id) {
      MensajeInfo("Debe seleccionar una categoría fiscal.", "", "info");
      return;
    }
    useStoreIngresos.getState().insertRegistro();
  };

  useEffect(() => {
    if (Mercaderia && Mercaderia.Id && Mercaderia.Id > 0) {
      useStoreIngresos.getState().getUnidadPorDefecto();
    }
    else {
      useStoreIngresos.setState({ Unidad: { Id: 3, sCodigo: "P", sDescripcion: "Kilos" } });
    }
  }, [Mercaderia]);

  return (
    <div className="ing-bloque-form" >
      <h4 className="ing-subtitulo">{EsProductoTerminado ? "Producto terminado" : "Materia Prima / Insumo"}</h4>
      <div className="ing-fila-flex">
        <div className="ing-campo">
          <div className="camp-o">
            {!Mercaderia || !Mercaderia.Id || Mercaderia === "" && (
              <span className="mensaje-obligatorio">*</span>
            )}
            <label htmlFor="productoNombre">Nombre:</label>
          </div>
          <BuscadorMercaderias
            Buscar={useStoreIngresos.getState().getMercaderia}
            LimpiarResultados={useStoreIngresos.getState().limpiarResultadosMercaderias}
            setValor={(e) => useStoreIngresos.setState({ Mercaderia: e })}
            Seleccionado={Mercaderia} TituloNoSeleccionado={"Nueva mercadería"} />
        </div>



        <div>
          <label htmlFor="lote">Lote de fabricación:</label>
          <div className="ing-campo">
            <input
              name="lote"
              value={Lote}
              onChange={(e) => useStoreIngresos.setState({ Lote: e.target.value })}
              placeholder="0000"
              autoComplete="off"
            />
          </div>
        </div>



       

        <div className="prod-campos" style={{ display: 'flex', alignItems: 'start', gap: '0px' }}>

          <div className="ing-campo" style={{  paddingRight: "12px" }}>
            <div className="camp-o" >
              <span className="mensaje-obligatorio">*</span>
              <label htmlFor="kilos">Cantidad</label>
            </div>
            <input
              type="number"
              name="kilos"
              placeholder="0000"
              value={EsProductoTerminado ? Cantidad : Peso}
              onChange={(e) =>
                useStoreIngresos.setState(EsProductoTerminado
                  ? { Cantidad: e.target.value }
                  : { Peso: e.target.value })
              }
            />
          </div>

          <div className="ing-campo" style={{  paddingRight: "12px" }} >
            <div className="camp-o">
              {!Unidad || !Unidad.Id || Unidad === "" && (
                <span className="mensaje-obligatorio">*</span>
              )}
              <label htmlFor="productoNombre" style={{marginBottom: "2px"}}>Medida</label>
            </div>
            <div>
              <ListaDesplegable Lista={ListaUnidades} Buscando={buscandoUnidades}
              setValor={(e) => useStoreIngresos.setState({ Unidad: e })}
              Seleccionado={Unidad} TituloNoSeleccionado={"Nueva unidad"} SoloLectura={Mercaderia && Mercaderia.Id && Mercaderia.Id > 0} />
            </div>
          </div>


        </div>

        {EsProductoTerminado && (
          <>
            <div className="ing-campo">
              <label htmlFor="precioCosto">Costo unitario:</label>
              <InputNumber
                inputId="precioCosto"
                value={PrecioCosto}
                onValueChange={(e) => useStoreIngresos.setState({ PrecioCosto: e.value ?? 0 })}
                mode="currency"
                currency="ARS"
                locale="es-AR"
                min={0}
              />
            </div>
            <div className="ing-campo">
              <div className="camp-o"><span className="mensaje-obligatorio">*</span><label htmlFor="precioVenta">Precio de venta:</label></div>
              <InputNumber
                inputId="precioVenta"
                value={PrecioVenta}
                onValueChange={(e) => useStoreIngresos.setState({ PrecioVenta: e.value ?? 0 })}
                mode="currency"
                currency="ARS"
                locale="es-AR"
                min={0}
              />
            </div>
          </>
        )}

        {EsMercaderiaNueva && (
          <div className="ing-campo">
            <div className="camp-o">
              <span className="mensaje-obligatorio">*</span>
              <label htmlFor="categoriaFiscalIngreso">Categoría fiscal:</label>
            </div>
            <select
              id="categoriaFiscalIngreso"
              value={CategoriaFiscal?.Id || ""}
              disabled={CargandoCategoriasFiscales}
              onChange={(e) => {
                const categoria = ListaCategoriasFiscales.find((item) => item.Id === Number(e.target.value)) || null;
                useStoreIngresos.setState({ CategoriaFiscal: categoria, PorcentajeIVA: categoria?.PorcentajeIVA ?? 21 });
              }}
            >
              <option value="">{CargandoCategoriasFiscales ? "Cargando categorías..." : "Seleccione una categoría"}</option>
              {ListaCategoriasFiscales.map((categoria) => (
                <option key={`${categoria.Id}-${categoria.Version}`} value={categoria.Id}>
                  {formatearCategoriaFiscal(categoria)}{categoria.Predeterminada ? " (predeterminada)" : ""}
                </option>
              ))}
            </select>
            {ErrorCategoriasFiscales && <small className="mensaje-obligatorio">{ErrorCategoriasFiscales}</small>}
            <small>Se aplica IVA 21 % por defecto. Cambialo solamente si corresponde.</small>
          </div>
        )}



        {/* Fecha Vencimiento */}
        <div className="ing-campo">
          <label htmlFor="vencimiento">Fecha Vencimiento:</label>
          <div className="ing-calendario-completo">
            <Calendario
              Fecha={FechaVencimiento}
              setFecha={(fecha) => useStoreIngresos.setState({ FechaVencimiento: fecha })}
            />
          </div>
        </div>


        <div className="ing-campo-repetir input-repetir" style={{ display: 'flex', flexDirection: 'row' }}>
          <div className="camp-o">
            <label>Repetir:</label>
          </div>
          <div style={{ display: 'flex' }}>
            <InputNumber inputId="minmax"
              inputStyle={{ backgroundColor: 'white', color: 'black' }}
              style={{ width: "60px" }}
              value={Etiquetas} onValueChange={(e) => useStoreIngresos.setState({ Etiquetas: e.value })} min={0} max={50} />
            <div className="camp-o" style={{ marginLeft: '8px' }}>
              <label>{Etiquetas === 1 ? "Vez" : "Veces"}</label></div>

            {open && (
              <div className="tutorial">
                <div>
                  <button
                    onClick={() => setOpen(false)}
                    className="btn-cerrar-tutorial"
                    style={{ color: 'white', background: '#545454', borderRadius: '5px', padding: '3px' }}
                  >
                    ✕
                  </button>

                  <div style={{ marginTop: '1.5rem' }}>
                    <img
                      src={"/Imagenes/InfoRepetir.jpeg"}
                      className={`video-tutorial ${open ? "show" : ""}`}
                      style={{ width: "300px", height: "450px" }}
                    />
                  </div>
                </div>
              </div>
            )}

          </div>
          <div style={{ width: '60px' }}>

          </div>
        </div>

        <span className="mensaje-obligatorio">* Campo obligatorio</span>

        <BlockUI blocked={Procesando}
          template={<ProgressSpinner style={{ width: '24px', height: '24px', color: "white" }} strokeWidth="8" animationDuration="5.15s" />} >
          <div className="ing-cta" style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
            <button onClick={Guardar} type="submit" style={{ backgroundColor: 'var(--app-brand)', color: 'white', width: '100%', fontSize: '1rem', padding: '12px 16px', borderRadius: '12px' }}>Agregar</button>
          </div>
        </BlockUI>

      </div>
    </div>
  )
}
